import React from 'react';
import FormPageShell from '../components/Common/FormPageShell';
import PageHeader from '../components/Common/PageHeader';
import { getAppHomePath } from '../constants/navigation';
import { useTranslation } from 'react-i18next';
import SettingsPublicPagesTab from './Settings/SettingsPublicPagesTab';
import SettingsTenantProfileTab from './Settings/SettingsTenantProfileTab';
import SettingsBrandingTab from './Settings/SettingsBrandingTab';
import SettingsRulesTab from './Settings/SettingsRulesTab';
import SettingsSubscriptionTab from './Settings/SettingsSubscriptionTab';

const Settings = () => {
  const { t } = useTranslation(['settings', 'common']);

  const headerBar = (Icon, title, description) => (
    <div className="border-b border-gray-100 bg-gradient-to-r from-slate-50/80 to-white px-5 py-4 sm:px-6">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-800 ring-1 ring-primary-200/50">
          <Icon className="h-5 w-5" aria-hidden />
        </div>
        <div>
          <h2 className="text-base font-semibold tracking-tight text-gray-900">{title}</h2>
          {description ? <p className="text-xs text-gray-500">{description}</p> : null}
        </div>
      </div>
    </div>
  );

  return (
    <FormPageShell>
      <div className="space-y-6">
        <PageHeader
          title={t('title')}
          description={t('description')}
          breadcrumbs={[{ label: t('common:home'), to: getAppHomePath() }, { label: t('title') }]}
        />
        <SettingsTenantProfileTab headerBar={headerBar} />
        <SettingsBrandingTab headerBar={headerBar} />
        <SettingsPublicPagesTab headerBar={headerBar} />
        <SettingsRulesTab headerBar={headerBar} />
        <SettingsSubscriptionTab headerBar={headerBar} />
      </div>
    </FormPageShell>
  );
};

export default Settings;
